import { NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function AppSidebar() {
    const { hasPermission, user } = useAuth();

    useEffect(() => {
        // Pending requisitions logic removed as per stock-only consolidation
    }, []);

    const menuItems = Number(user?.id) === 0 ? [
        { label: 'Cargos Globais', path: '/master/cargos', icon: 'ri-shield-user-fill', visible: true },
        { label: 'Checklists Globais', path: '/master/checklists', icon: 'ri-checkbox-multiple-line', visible: true },
        { label: 'Normas (NRs)', path: '/master/nrs', icon: 'ri-book-read-fill', visible: true },
        { label: 'Pânico & Fluxos', path: '/master/panico', icon: 'ri-alarm-warning-fill', visible: true },
        { label: 'Configurações', path: '/configuracoes', icon: 'ri-settings-4-fill', visible: true },
    ] : [
        { label: 'Intelligence', path: '/analytics/dashboard', icon: 'ri-pie-chart-2-fill', visible: hasPermission('pcm', 'ver') },
        { label: 'PCM', path: '/pcm/dashboard', icon: 'ri-dashboard-3-fill', visible: hasPermission('pcm', 'ver') },
        { label: 'TST', path: '/tst', icon: 'ri-shield-check-fill', visible: true },
        { label: 'Agenda', path: '/agenda', icon: 'ri-calendar-todo-fill', visible: hasPermission('pcm', 'ver') },
        { label: 'Técnico', path: '/pcm/tecnico', icon: 'ri-tools-fill', visible: hasPermission('pcm', 'ver') && (user?.cargo_nome === 'Técnico' || user?.cargo_nome === 'Admin') },
        { label: 'Operador', path: '/pcm/operador/scan', icon: 'ri-barcode-box-fill', visible: hasPermission('pcm', 'ver') && (user?.cargo_nome === 'Operador' || user?.cargo_nome === 'Admin') },
        { label: 'Estoque', path: '/estoque', icon: 'ri-archive-fill', visible: hasPermission('suprimentos', 'ver') },
        { label: 'Financeiro', path: '/financeiro', icon: 'ri-money-dollar-circle-fill', visible: hasPermission('financeiro', 'ver') },
        { label: 'Configurações', path: '/configuracoes', icon: 'ri-settings-4-fill', visible: hasPermission('configuracoes', 'ver') },
    ];

    const visibleItems = menuItems.filter(item => item.visible);

    return (
        <aside className="w-20 bg-white border-r border-gray-200 flex flex-col items-center py-4 z-50 h-full">
            <nav className="flex-1 flex flex-col space-y-4 w-full px-2">
                <NavLink
                    to="/"
                    className={({ isActive }) =>
                        `group relative flex items-center justify-center w-full aspect-square rounded-xl transition-all duration-200 ${isActive
                            ? 'bg-teal-50 text-teal-600 shadow-sm'
                            : 'text-gray-400 hover:bg-gray-50 hover:text-gray-600'
                        }`
                    }
                >
                    <i className="ri-apps-2-line text-2xl"></i>
                    <div className="absolute left-full ml-3 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50">
                        Apps
                    </div>
                </NavLink>

                {visibleItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                            `group relative flex items-center justify-center w-full aspect-square rounded-xl transition-all duration-200 ${isActive
                                ? 'bg-teal-50 text-teal-600 shadow-sm'
                                : 'text-gray-400 hover:bg-gray-50 hover:text-gray-600'
                            }`
                        }
                    >
                        <i className={`${item.icon} text-2xl`}></i>

                        {/* Tooltip */}
                        <div className="absolute left-full ml-3 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50">
                            {item.label}
                        </div>

                        {/* Badge removed with Suprimentos */}
                    </NavLink>
                ))}
            </nav>

            {/* Trial Status Footer */}
            {(user?.status_assinatura === 'trial' || user?.status_assinatura === 'pendente') && (
                <div className="w-full px-2 py-4 border-t border-gray-100 mt-auto">
                    <div className="group relative flex flex-col items-center justify-center w-full aspect-square rounded-xl bg-orange-50 text-orange-600 transition-all duration-200">
                        <i className="ri-time-line text-xl"></i>
                        <span className="text-[10px] font-bold mt-1">TESTE</span>

                        {/* Status Tooltip/Hover Info */}
                        <div className="absolute left-full ml-3 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-50 shadow-xl border border-gray-800">
                            <div className="font-bold text-orange-400 mb-1">Período de Teste</div>
                            <div className="text-gray-300">
                                {user?.data_expiracao ? (
                                    <>
                                        Expira em: {new Date(user.data_expiracao).toLocaleDateString()}
                                        <div className="mt-1 text-[10px] text-gray-400 uppercase tracking-wider">
                                            {Math.ceil((new Date(user.data_expiracao).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))} dias restantes
                                        </div>
                                    </>
                                ) : (
                                    "30 dias de acesso gratuito"
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </aside>
    );
}
